export default {
  campaignsList: {
    nextPageToken: "",
    data: []
  },
  campaign: {},
  campaignReport: {},
  campaignPreview: {}
};
